export const levelDescription = {
  ADOPT: 'The highest technology level to accept or start for using',
  TRIAL:
    'Test level, usually over a limited period of time, to discover how technology is effective or suitable',
  ASSESS:
    'Level to measure or evaluate, judge or appraise the quality, value, or nature of Technologies',
  HOLD: 'Level assigned to a technology when there are issues, delays, or uncertainties. It indicates that progress is temporarily halted'
};
